// extracted by mini-css-extract-plugin
module.exports = {"activeUserGroupArea":"UserGroupSelector_activeUserGroupArea__NMvSJ","inActiveUserGroupArea":"UserGroupSelector_inActiveUserGroupArea__lVtt4"};